import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';

const controller = rpcController("ManifiestoRAD");


export const ManifiestoRAD = cacheResource({
    /**Consulta de las guias */
    Consultar: async (filtro: models.FiltroManifiestosRAD): Promise<models.ManifiestoRADDto[]> => await controller('Consultar', {}, filtro),


    /**Marca como terminada una recolección */
    CancelarManifiesto: async (idManifiestoRAD: number): Promise<void> => await controller('CancelarManifiesto', { idManifiestoRAD }),

    /**Marca como terminada una recolección */
    TerminarManifiesto: async (idManifiestoRAD: number): Promise<void> => await controller('TerminarManifiesto', { idManifiestoRAD }),

    /**Agrega un manifiesto de RAD a la base de datos, verificando que las guias sean congruentes con los datos del manifiesto y que no se esten agregando guias repetidas */
    AgregarManifiesto: async (model: models.NuevoManifiestoRADModel): Promise<void> => await controller('AgregarManifiesto', {}, model),

    /**Devuelve el reporte de impresión de manifiesto */
    ImprimirManifiesto: async (idManifiestoRAD: number): Promise<string> => await controller('ImprimirManifiesto', { idManifiestoRAD }),

    /**Obtiene todas las guias que pueden formar parte de un nuevo manifiesto */
    ObtenerGuiasNuevoManifiesto: async (idDireccionClienteOrigen: number, idSucursalOrigen: number): Promise<models.GuiaDTO[]> => {
        console.log("Obtener");
        return await controller('ObtenerGuiasNuevoManifiesto', { idDireccionClienteOrigen, idSucursalOrigen });   
    },
}, {
    //NOTA: No se debe de memoizar el ObtenerGUiasNuevoManifiesto porque si los clientes dejan abierto el sistema no van a ver las nuevas
    //guías ya que el cache va a devolver las guias anteriores
    }, {
        CancelarManifiesto: true,
        TerminarManifiesto: true,
        AgregarManifiesto: true,
    })


// WEBPACK FOOTER //
// ./app/resources/items/manifiestorad.tsx